export default __webpack_public_path__ + "static/char-thumb-14-421ae320453f3af94c9d58a77f68cd07.png";